import { useCookieConsent } from '@packages/utilities';
import { useEffect } from 'react';
import { useTracking } from '../../../hooks';
import { ExternalScriptTestIds } from '../types';

export const SmartAssistant = ({ advisorCode }: { advisorCode: string }) => {
  const isAllowed: boolean = useCookieConsent('C0002');
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (isAllowed) {
      dispatchGTMEvent({
        event: 'renderSmartAssistantScript',
        eventValue: {
          smartAssistantAdvisorCode: advisorCode,
        },
      });
    }
  }, [advisorCode, dispatchGTMEvent, isAllowed]);

  return isAllowed ? (
    <div id="advisor-container" data-testid={ExternalScriptTestIds.SmartAssistantScript} />
  ) : (
    <div
      data-testid={ExternalScriptTestIds.SmartAssistantScriptNotAllowed}
      id="smartAssistant-not-allowed"
    />
  );
};
